import React, { useEffect } from 'react';
import { useAppSelector } from '../../../store/Hooks';
import { PageHeaderSection } from '../../../components/common/PageHeadSection';
import { useTranslation } from "react-i18next";

const StopFreeSaleUserManual = () => {
    const language = useAppSelector((store) => store.site.language);
    const [userManualPath, setUserManualPath] = React.useState<string>();
    const { t } = useTranslation();

    useEffect(() => {
        getUserManualPathByLanguage();
    }, [language]);

    const getUserManualPathByLanguage = () => {
        if (language) {
            setUserManualPath(require(`../../../assets/manuals/News-${language.split("-")[0]}.pdf`));
        }
    };

    return (
        <div className="nk-content">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <PageHeaderSection
                            pageTitle={t("help.userManual.news")}
                        />
                        {userManualPath && (
                            <iframe
                                src={userManualPath}
                                width="100%"
                                height="650px"
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StopFreeSaleUserManual;
